<template>
  <span>
    <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
        <path d="M12,3 C7.05,3 3,7.05 3,12 C3,16.95 7.05,21 12,21 C16.95,21 21,16.95 21,12 C21,7.05 16.95,3 12,3 Z M4.8,12 C4.8,8.04 8.04,4.8 12,4.8 C13.62,4.8 15.15,5.34 16.41,6.33 L6.33,16.41 C5.34,15.15 4.8,13.62 4.8,12 Z M12,19.2 C10.38,19.2 8.85,18.66 7.59,17.67 L17.67,7.59 C18.66,8.85 19.2,10.38 19.2,12 C19.2,15.96 15.96,19.2 12,19.2 Z" id="path-Filter-Switch"></path>
      </defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="icons/not" transform="translate(-3.000000, -3.000000)">
          <rect id="Bounding-Box-Filter-Switch" x="0" y="0" width="24" height="24"></rect>
          <mask id="mask-2-filter-Switch" fill="white">
            <use xlink:href="#path-Filter-Switch"></use>
          </mask>
          <use id="Shape" fill="#000000" fill-rule="nonzero" xlink:href="#path-Filter-Switch"></use>
          <g id="Mixin/Fill/Active" mask="url(#mask-2-filter-Switch)" :fill="fill" fill-rule="evenodd">
            <rect class="filter-switch" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </svg>
  </span>
</template>

<script>
export default {
  name: "DsFilterSwitchIcon",
  props: {
    fill: {
      type: String,
      default: "#8D99AE"
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../scss/_variables.scss";

svg {
  rect.filter-switch {
    transition: fill $transition-duration;
    &:hover {
      transition: fill $transition-duration;
      fill: $extra-light-blue-color;
    }
  }
  .switch-shape--active {
    fill: $light-green-color;
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/icons/ds-filter-switch-icon.vue